// extracted by mini-css-extract-plugin
module.exports = {"root":"create_dialog_content_root__3mKLr","menu":"create_dialog_content_menu__3g0U-","content":"create_dialog_content_content__3-AJF","inner":"create_dialog_content_inner__3pbNP"};